import { render, staticRenderFns } from "./userPoster.vue?vue&type=template&id=0868b466&scoped=true&"
import script from "./userPoster.vue?vue&type=script&lang=js&"
export * from "./userPoster.vue?vue&type=script&lang=js&"
import style0 from "./userPoster.vue?vue&type=style&index=0&id=0868b466&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0868b466",
  null
  
)

export default component.exports